<div class="px-[8px] py-[16px] flex flex-col gap-[16px] h-full">
    <div class="flex flex-col gap-[16px]">
        <div class="close-dialog  cursor-pointer" (click)="close()">
            <mat-icon class="text-[25px] text-black absolute right-2 w-[24px] h-[24px]">close</mat-icon>
        </div>
        <div class="icons-btn-group flex justify-center gap-[16px]">
        </div>
        <header class="text-[#000000bf] flex flex-row justify-center sm:flex-nowrap gap-4">
            <div class="player-item flex gap-2 items-center w-max items-center ">
                <div class="p-1 border border-black/30 rounded-2xl hidden sm:block">
                    <img src="icons/profile.svg" class="w-6 h-6 opacity-50" alt="">
                </div>
                <div class="flex flex-col items-center  w-max">
                    <div class="field">
                        <h1 class="text-[18px] md:text-[24px] font-bold text-[#0066CC]">{{player?.username}}</h1>
                    </div>
                    <div class="field-name">
                        <span class="text-[12px] opacity-50 font-bold truncate block">{{'common.username' | transloco}}</span>
                    </div>
                </div>
            </div>
            <div class="player-item flex flex-col w-max  items-center ">
                <div class="field">
                    <h1 class="text-[18px] md:text-[24px] font-bold text-[#0066CC]">{{player?.name}} {{player.surname}}</h1>
                </div>
                <div class="field-name">
                    <span class="text-[12px] opacity-50 font-bold truncate block">{{'common.firstName' | transloco}} & {{'common.lastName' | transloco}}</span>
                </div>
            </div>
            <div class="player-item flex flex-col w-max  items-center ">
                <div class="field">
                    <h1 class="text-[18px] md:text-[24px] font-bold text-[#0066CC]">{{player?.id}}</h1>
                </div>
                <div class="field-name">
                    <span class="text-[12px] opacity-50 font-bold truncate block">{{'reports.sport-book.bets.playerId' | transloco}}</span>
                </div>
            </div>
        </header>
        
    </div>
    <div class="grid grid-cols-2 gap-5 overflow-y-auto border border-black/10 p-[8px] rounded-2xl">
        @for (item of financialData; track item.label) {
            <div class="player-item flex flex-col min-w-max">
                <div class="field">
                    
                    <h1 class="text-[16px] font-semibold">{{ item.value }}</h1>
                </div>
                <div class="field-name flex items-center">
                    @if(item.icon != ''){
                        <mat-icon  class="mr-2" svgIcon="{{item.icon}}"></mat-icon>
                        }
                    <span class="text-[12px] opacity-50 font-semibold truncate block">{{ item.label | transloco }}</span>
                </div>
            </div>
        }
        
        <div class="player-item flex flex-col justify-between min-w-max">
            <div class="field flex flex-col">
                @if (player.accountVerified === true) {
                    <span>
                        <mat-icon class="text-[25px] text-blue-500">check</mat-icon>
                    </span>
                } @else if (player.accountVerified === false) {
                    <mat-icon class="text-[25px] text-red-500">close</mat-icon>
                } @else {
                    {{ item.value }}
                }
            </div>
            <div class="field-name">
                <span class="text-[12px] opacity-50 font-semibold truncate block">{{ 'players.withdrawals.popup.accountVerified' | transloco }}</span>
            </div>
        </div>

        <div class="player-item flex flex-col justify-between min-w-max">
            <div class="field flex flex-col">
                @if (player.phoneNoVerified === true) {
                    <span>
                        <mat-icon class="text-[25px] text-blue-500">check</mat-icon>
                    </span>
                } @else if (player.phoneNoVerified === false) {
                    <mat-icon class="text-[25px] text-red-500">close</mat-icon>
                } @else {
                    {{ item.value }}
                }
            </div>
            <div class="field-name">
                <span class="text-[12px] opacity-50 font-semibold truncate block">{{ 'players.withdrawals.popup.phoneNoVerified' | transloco }}</span>
            </div>
        </div>

        <div class="player-item flex flex-col justify-between min-w-max">
            <div class="field flex flex-col">
                    <mat-icon class="text-[25px] text-red-500">close</mat-icon>
            </div>
            <div class="field-name">
                <span class="text-[12px] opacity-50 font-semibold truncate block">KYC Status</span>
            </div>
        </div>
    </div>
</div>